import { ScanQR } from '@components/SwitchToMobile/steps/ScanQR'
import { SwitchToMobileFlow } from './SwitchToMobileFlow'

export type { GetSwitchToMobileContextResponse } from './SwitchToMobileFlow'

export const SwitchToMobilePage = () => <SwitchToMobileFlow ScanQRComponent={ScanQR} />
